import _root_default from "./_root.js";
import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_DataView.js
var DataView = _getNative_default(_root_default, "DataView");
var _DataView_default = DataView;

//#endregion
export { _DataView_default as default };
//# sourceMappingURL=_DataView.js.map